<template>
  <el-dialog :visible.sync="formVisible" :close-on-click-modal="false" width="520px" class="reject-dialog"
    @close="handleClose">
    <div slot="title" class="dialog-title">
      <img src="../../../assets/icon-reject.png" alt="reject" class="title-icon" />
      <div class="title-content">
        <div class="title-main">驳回申请</div>
      </div>
    </div>
    <div class="dialog-body">
      <div class="detail-box" v-if="currentRow">
        <div class="detail-item">
          <span class="label">用户信息：</span>
          <span class="value">{{ currentRow.customerInfo }}</span>
        </div>
        <div class="detail-item">
          <span class="label">申请内容：</span>
          <span class="value">{{ `原折扣${currentRow.fromProfitRatio}  修改成:${currentRow.toProfitRatio}` }}</span>
        </div>
        <div class="detail-item">
          <span class="label">申请原因：</span>
          <span class="value">{{ currentRow.reason || '-' }}</span>
        </div>
        <div class="detail-item" v-if="getVoucherImages(currentRow).length > 0">
          <span class="label">申请凭证：</span>
          <div class="voucher-imgs">
            <el-image v-for="(img, idx) in getVoucherImages(currentRow)" :key="idx"
              style="width: 60px; height: 60px; margin-right: 8px;" :src="img"
              :preview-src-list="getVoucherImages(currentRow)" />
          </div>
        </div>
      </div>
      <el-form v-if="currentRow" ref="rejectForm" :model="form" :rules="formRules" label-width="110px" class="reject-form">
        <el-form-item label="申请人：">
          <div>{{ currentRow.submitUserName }}</div>
        </el-form-item>
        <el-form-item label="提交时间：">
          <div>{{ currentRow.createdTime }}</div>
        </el-form-item>
        <el-form-item label="驳回原因：" prop="reason" class="reason-input">
          <el-input v-model="form.reason" type="text" placeholder="请输入驳回原因" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doReject" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      formVisible: false,
      isLoading: false,
      currentRow: null,
      form: {
        reason: ''
      },
      formRules: {
        reason: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleCreate(row) {
      this.currentRow = row
      this.form.reason = ''
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs.rejectForm && this.$refs.rejectForm.clearValidate()
      })
    },
    handleClose() {
      this.currentRow = null
      this.form.reason = ''
    },
    formatUserInfo(row) {
      if (row.targetUserName && row.targetUserLevelName && row.targetUserMobile) {
        return `${row.targetUserName}-${row.targetUserLevelName}-${row.targetUserMobile}`
      }
      return row.userInfo || '-'
    },
    formatApplicantInfo(row) {
      if (row.applicantName && row.applicantLevelName && row.applicantMobile) {
        return `${row.applicantName}-${row.applicantLevelName}-${row.applicantMobile}`
      }
      return row.applicantInfo || '-'
    },
    getVoucherImages(row) {
      if (!row) return []
      if (row.imgUrl) {
        return row.imgUrl.split(',').filter(Boolean)
      }
      return []
    },
    doReject() {
      this.$refs.rejectForm.validate(valid => {
        if (valid && this.currentRow && this.currentRow.id) {
          this.isLoading = true
          this.$emit('reject', {
            id: this.currentRow.id,
            reason: this.form.reason
          }, () => {
            this.isLoading = false
            this.formVisible = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reject-dialog ::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
}

.reject-dialog ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}

.dialog-title {
  display: flex;
  gap: 20px;

  .title-icon {
    width: 60px;
  }

  .title-content {
    .title-main {
      font-size: 18px;
      color: #000000;
    }

    .title-sub {
      font-size: 14px;
      color: #8F8E8E;
      padding-top: 10px;
    }
  }
}

.detail-box {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .detail-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 16px;
    line-height: 14px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      color: #666666;
      display: inline-block;
    }

    .value {
      color: #6C6C6C;
    }

    .voucher-imgs {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
}

.reject-form {
  margin-top: 20px;

  .el-form-item {
    margin-bottom: 16px;

    ::v-deep .el-form-item__label {
      line-height: 14px;
      font-size: 16px;
      text-align: right;
      color: #666666;
    }

    ::v-deep .el-form-item__content {
      line-height: 14px;
      font-size: 16px;
      color: #666666;
    }

    &.reason-input {
      ::v-deep .el-form-item__label {
        line-height: 40px;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
